@import "@/scss/use-bootstrap-mixins.scss";

.question {
  padding: 4px 0;

  label {
    display: block;
    font-size: 18px;
    font-weight: 500 !important;
  }

  select {
    width: 100%;
    border: 1px solid #d0d0d0;
    border-radius: 4px !important;
    padding: 13px 15px;
    font-size: 14px;
    background-color: #fff;

    &:disabled {
      background-color: #f0f0f0;
      -webkit-animation: pulse 0.7s;
      -webkit-animation-iteration-count: 100;
      animation: pulse 0.7s;
      animation-iteration-count: 100;
    }

    &.invalid {
      border-color: #d04d52;
    }

    @-webkit-keyframes pulse {
      from {
        border-color: #d0d0d0;
      }
      50% {
        border-color: $primary;
      }
      to {
        border-color: #d0d0d0;
      }
    }
    @keyframes pulse {
      from {
        border-color: #d0d0d0;
      }
      50% {
        border-color: $primary;
      }
      to {
        border-color: #d0d0d0;
      }
    }
  }
}
